import React from 'react';
import image3D from '../assets/3D.png'; // ✅ Check image path

const JobReadyProgram = () => {
  return (
    <div
      style={{
        padding: '40px',
        fontFamily: 'sans-serif',
        background: 'white',
        minHeight: '100vh',
      }}
    >
      {/* Heading + Image Row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {/* Left Section: Heading + Subheading + Small Container */}
        <div style={{ flex: '1', minWidth: '280px', marginLeft: '70px' }}>
          <h1 style={{ marginBottom: '10px', color: '#111', fontSize: '40px' }}>
            1 Year Job-Ready Program
          </h1>
          <p style={{ fontSize: '22px', color: '#111', marginBottom: '20px' }}>
            Become Job Ready in just 12 months!
          </p>

          {/* Program Overview Container */}
          <div
            style={{
              padding: '25px',
              background: '#4484CE',
              borderRadius: '12px',
              boxShadow: '0 6px 30px rgba(8, 127, 255, 0.15)',
              maxWidth: '340px',
              marginTop: '10px',
              transition: 'all 0.4s ease',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 123, 255, 0.35)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 6px 30px rgba(0, 123, 255, 0.15)';
            }}
          >
            <h2 style={{ marginBottom: '10px', color: '#111', fontSize: '20px' }}>
              Program Overview
            </h2>
            <p style={{ color: '#111', fontSize: '15px' }}>
              A unique, power-packed 12-month training program designed to make you job-ready with in-demand technical and professional skills. Master programming, build real-world projects, get internship experience, and land your dream job — all in just one year.
            </p>
          </div>
        </div>

        {/* Right Section: Image */}
        <div style={{ flex: '0 0 500px', textAlign: 'center', marginLeft: '-10px' }}>
          <img
            src={image3D}
            alt="3D Professor"
            style={{
              width: '100%',
              maxWidth: '400px',
              height: '500px',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      {/* Monthly Training Breakdown Heading */}
      <h2
        style={{
          marginTop: '50px',
          textAlign: 'center',
          color: '#111',
          fontSize: '26px',
        }}
      >
        Monthly Training Breakdown
      </h2>

      {/* Container for Monthly Breakdown */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          marginTop: '30px',
        }}
      >
        {/* First Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0, 123, 255, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 123, 255, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 123, 255, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Month 1 - 3: Foundation Phase</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Build strong programming fundamentals</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Programming Basics (C, C++, Python)</li>
            <li>Data Structures & Algorithms (DSA)</li>
            <li>Git & GitHub (Version Control)</li>
            <li>Hands-on Coding Practice</li>
            <li>Weekly Assignments and Doubts Sessions</li>
          </ul>
        </div>

        {/* Second Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 105, 180, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 105, 180, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 105, 180, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Month 4 - 6: Specialization Phase</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Master industry-demand technologies</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Frontend Development: HTML, CSS, JavaScript, React.js</li>
            <li>Backend Development: .NET Core / Node.js</li>
            <li>Database: SQL (MySQL/PostgreSQL)</li>
            <li>API Development & Integration</li>
            <li>Mini Projects to apply knowledge</li>
          </ul>
        </div>

        {/* Third Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 193, 7, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 193, 7, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 193, 7, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Month 7 - 9: Real-Life Projects Phase</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Simulated industry projects to boost experience</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Capstone Projects with Agile Process</li>
            <li>Team Collaboration & Git Workflows</li>
            <li>Client-Based Use Cases</li>
            <li>Weekly Code Reviews</li>
            <li>Project Documentation & Hosting</li>
          </ul>
        </div>

        {/* Fourth Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(76, 175, 80, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(76, 175, 80, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Month 10 - 12: Internship & Job Preparation</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Final polish before the job!</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Resume Building & Portfolio Website</li>
            <li>LinkedIn Profile Optimization</li>
            <li>Mock Interviews (Technical + HR)</li>
            <li>Communication & Soft Skills Training</li>
            <li>Internship/Live Project with Certificate</li>
          </ul>
        </div>
      </div>

      {/* Heading for the 6 Sections */}
<h2 style={{ textAlign: 'center', fontSize: '26px', color: '#222', marginTop: '60px' }}>
  Other Details
</h2>

            {/* 6 Sections Below - Key Features or Additional Modules */}
            <div
  style={{
    marginTop: '60px',
    maxWidth: '1000px',
    margin: 'auto',
    backgroundColor: '#fff',
    padding: '30px',
    fontFamily: 'sans-serif',
  }}
>
  {[
    [
      {
        title: '💰 Program Fee',
        desc: [
          'Total Cost: ₹5,000/- only',
          'Installments: One-time payment (No monthly fees)',
          'Note: Non-refundable, value-packed program',
        ],
      },
      {
        title: '✅ Eligibility Criteria',
        desc: [
          'College Student (Diploma / UG / PG)',
          'Pass-Out / Fresher Looking for Jobs',
          'Willing to Learn Practically',
          'Has Laptop + Internet',
          'Can Dedicate 3 Hours Daily',
        ],
      },
    ],
    [
      {
        title: '📜 Rules & Guidelines',
        desc: [
          'Complete weekly tasks',
          'Inactive participants may be removed',
          'Respect mentors & learners',
          'Group collaboration is key',
          'Certificates post-project submission',
        ],
      },
      {
        title: '🎁 What You Get',
        desc: [
          '1-Year Guided Training',
          'Resources & Assignments',
          'Internship & Project Certificates',
          'Mentor Support & Job Help',
          'Profile Building Support',
        ],
      },
    ],
    [
      {
        title: '📌 Why Choose This Program?',
        desc: [
          'Affordable one-time fee',
          'Career guidance & mentorship',
          'Hands-on learning',
          'Ideal for freshers & switchers',
        ],
      },
      {
        title: '📞 Get in Touch',
        desc: [
          '📧 Email: admin@willovate.in',
          '📱 WhatsApp: +91-8237883928',
        ],
      },
    ],
  ].map((row, rowIndex) => (
    <div key={rowIndex} style={{ marginBottom: '30px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '40px',
          position: 'relative',
        }}
      >
        {row.map((item, i) => (
          <div key={i} style={{ flex: '1', padding: '10px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '22px', color: '#111', marginBottom: '12px' }}>{item.title}</h3>
            <ul style={{ listStyleType: 'disc', marginLeft: '20px', color: '#444', padding: '0', textAlign: 'left' }}>
              {item.desc.map((point, index) => (
                <li key={index} style={{ marginBottom: '8px', fontSize: '16px' }}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
        {/* Vertical Line Between Boxes */}
        <div style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '50%',
          width: '1px',
          backgroundColor: '#ccc',
          transform: 'translateX(-50%)',
        }} />
      </div>
      {/* Horizontal line below each row */}
      {rowIndex < 2 && (
        <hr
          style={{
            marginTop: '30px',
            border: 'none',
            borderTop: '1px solid #ccc',
          }}
        />
      )}
    </div>
  ))}
</div>


      {/* Closing Note or Call to Action */}
<div style={{ marginTop: '60px', textAlign: 'center' }}>
  <h2 style={{ fontSize: '24px', color: '#111' }}>
    Ready to kickstart your tech career?
  </h2>
  <button
  style={{
    padding: '12px 24px',
    fontSize: '16px',
    backgroundColor: '#F19F4D',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(8, 8, 8, 0.3)',
    transition: 'background-color 0.3s ease',
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = '#d9883b'; // Slightly darker on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = '#F19F4D'; // Restore original color
  }}
  onClick={() => {
    window.open('https://forms.gle/VZfbRCurJkDGXdx7A', '_blank');
  }}
>
  Enroll Now
</button>
</div>
    </div>
  );
};

export default JobReadyProgram;
